module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3460956.5dd620fb.png";